import React from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'

import Editor from '~/webhooks/components/subscription_editor.jsx'

const EditSubscription = (props) => {
  const state = (props.location || {}).state || {}
  if (!state.url) {
    props.history.push('/subscriptions/new')
  }
  return (
    <Editor
      returnTo="/"
      name="Edit webhook"
      active={state.active}
      url={state.url}
      allowSave={true}
      allowDelete={true}
    />
  )
}

export default withRouter(EditSubscription)
